import { render } from "./AnnouncementDocument.vue?vue&type=template&id=08e8bcd7&scoped=true&ts=true"
import script from "./AnnouncementDocument.ts?vue&type=script&lang=ts"
export * from "./AnnouncementDocument.ts?vue&type=script&lang=ts"

import "./AnnouncementDocument.scss?vue&type=style&index=0&id=08e8bcd7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e8bcd7"]])

export default __exports__